import * as Types from '../../../../../graphql/src/lib/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdatePasswordWithTokenMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
}>;


export type UpdatePasswordWithTokenMutation = { __typename?: 'Mutation', updatePasswordWithToken: boolean };

export const UpdatePasswordWithTokenDocument = gql`
    mutation UpdatePasswordWithToken($token: String!, $password: String!) {
  updatePasswordWithToken(token: $token, password: $password)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePasswordWithTokenGQL extends Apollo.Mutation<UpdatePasswordWithTokenMutation, UpdatePasswordWithTokenMutationVariables> {
    override document = UpdatePasswordWithTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }